import apiClient from './api.service';

export interface ControlTowerQueryParams {
  date?: string;
  period?: 'today' | 'week' | 'month';
  date_from?: string;
  date_to?: string;
  customer_name?: string;
  project_name?: string;
  execution_scope?: string;
  work_order_status?: string;
  supervisor_user_id?: string;
  search?: string;
  page?: number;
  page_size?: number;
}

const base = '/manufacturing/control-tower';

export const manufacturingControlTowerService = {
  getSummary: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/summary`, { params }),
  getExecutionMonitor: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/execution-monitor`, { params }),
  getFabricationUnits: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/fabrication-units`, { params }),
  getInspections: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/inspections`, { params }),
  getOutsourced: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/outsourced`, { params }),
  getDeliveryReadiness: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/delivery-readiness`, { params }),
  getTraceability: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/traceability`, { params }),
  getMaterialReadiness: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/material-readiness`, { params }),
  getProductionRequests: () => apiClient.get(`${base}/production-requests`),
  getRouteSheets: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/route-sheets`, { params }),
  getDocumentCollections: () => apiClient.get(`${base}/document-collections`),
  getBottlenecks: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/bottlenecks`, { params }),
  getTimeline: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/timeline`, { params }),
  getAnalytics: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/analytics`, { params }),
  getAlerts: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/alerts`, { params }),
  getBrief: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/brief`, { params }),
  getAttentionQueue: (params?: ControlTowerQueryParams) =>
    apiClient.get(`${base}/attention-queue`, { params }),
};

export default manufacturingControlTowerService;
